import jquery from 'jquery';
import EFOcats_event_core from './efocats_event_core.js';

/**
 * 回答した時のイベント
 */
export default class EFOcats_event_input extends EFOcats_event_core {
  /**
   * コンストラクタ
   * @param validations エラーチェック処理配列
   */
  constructor() {
    super();
    this.file_close_flag = false;
  }

  /**
   * イベントための事前の仕込み
   */
  init() {
    // 特に処理なし
  }

  /**
   * イベント本体をセット
   */
  event() {
    this.autokana();

    this.$('body').on('change.answer', 'input,select,textarea', event => {
      const element = event.currentTarget;
      this.answer_ev(jquery(element));
    });
  }

  /**
   * 回答イベント
   * @param obj
   */
  answer_ev(obj) {
    if (!obj.parents('section').hasClass('action')) {
      return;
    }

    /*
        if (obj.parent(".check-flag").hasClass("yubin-num")) {
            return;
        }
        */

    if (obj.attr('type') === 'tel') {
      this.rep_yubin(obj);
    }

    const status_data = {status: ''};

    // エラーチェック
    efocats.validations.check_error(obj);

    if (obj.attr('type') === 'file') {
      this.file_disp_change(obj, status_data);
    }

    efocats.submit.status_individual(obj);
  }

  /**
   * ファイル表示
   * @param obj
   * @param status_data
   */
  file_disp_change(obj, status_data) {
    if (status_data.status === 'success' && this.file_close_flag !== true) {
      const text = this.getImgName(obj);
      obj.parents('.label-file').addClass('hidden');
      obj.parents('.label-file').after(`<div class="file-upload-btn disp"><span class="text">${text}</span><span class="close"></span></div>`);
      this.file_disp_close();
    } else {
      obj.parents('.label-file').removeClass('hidden');
      obj.parents('.label-file').next('.file-upload-btn').remove();
      this.file_close_flag = false;
    }
  }

  /**
   * ファイル非表示
   */
  file_disp_close() {
    this.$('.file-upload-btn.disp .close').on('click', event => {
      const element = event.currentTarget;
      this.file_close_flag = true;
      jquery(element).parents('.qa').find('input[type="file"]').val('');
      this.answer_ev(jquery(element).parents('.qa').find('input[type="file"]'));
    });
  }

  /**
   * 画像ファイル名取得
   * @param checkData
   */
  getImgName(checkData) {
    const {name} = checkData[0].files[0];
    return name;
  }

  /**
   * カナ自動入力
   */
  autokana() {
    if (typeof window.jQuery === 'undefined') {
      window.jQuery = require('jquery');
    }

    const $ = window.jQuery;

    require('jquery.autokana');

    // autokanaを呼び出し
    this.$("[data-input^='input']").each((index, elem) => {
      const input_val = $(elem).attr('data-input').replace('input', 'output');
      $.fn.autoKana($(elem), this.$(`input[data-input='${input_val}']`), {
        katakana: true,
      });
    });

    this.$("[data-input^='input']")
      .parents('.container')
      .find('.next-btn')
      .on('click', () => {
        this.$("[data-input^='input']").each((index, elem) => {
          const input_val = $(elem).attr('data-input').replace('input', 'output');
          const value = this.$(`input[data-input='${input_val}']`).val();

          if (value) {
            this.$(`input[data-input='${input_val}']`).parents('.check-flag').addClass('ok-flag').addClass('icon-flag');
          } else {
            this.$(`input[data-input='${input_val}']`).parents('.check-flag').removeClass('ok-flag').removeClass('icon-flag');
          }
        });
        if (
          this.$("[data-input^='output']").parents('.container').find('.ok-flag').length >=
          this.$("[data-input^='output']").parents('.container').find("[data-input^='output']").length
        ) {
          this.$("[data-input^='output']").parents('.qa').addClass('go-flag');
        } else {
          this.$("[data-input^='output']").parents('.qa').removeClass('go-flag');
        }
      });
  }
}
